import React from 'react';
import './HowToUse.css';

const HowToUse = () => {
  return (
    <div className="howto-wrapper">
      <div className="howto-container">
        <h1 className="howto-title">How to Use the Material Calculator & Quotation Builder</h1>

        <section className="howto-section">
          <h2>System Overview</h2>
          <p>This portal helps in estimating construction costs accurately. It supports:</p>
          <ul>
            <li><strong>Heading 1 - Material Type:</strong> Consists of multiple materials with formulas.</li>
            <li><strong>Heading 2 - Fixed Type:</strong> Has predefined pricing based on characteristics and makes.</li>
          </ul>
        </section>

        <section className="howto-section">
          <h2>Material Calculator</h2>
          <ol>
            <li>Enter <strong>Quantity</strong> for a selected Heading (Type 1).</li>
            <li>System lists required <strong>materials</strong> with units and prices.</li>
            <li>Final material cost is calculated automatically.</li>
          </ol>
        </section>

        <section className="howto-section">
          <h2>Quotation Builder</h2>
          <ol>
            <li>Add a <strong>Heading</strong> (Type 1 or Type 2).</li>
            <li>Enter <strong>measurement</strong> and <strong>extra costs</strong> (cartage, installation, wastage, profit).</li>
            <li>Quotation is auto-calculated with applied logic.</li>
          </ol>
        </section>

        <section className="howto-section">
          <h2>Adding a Heading (Type 1 - Material Based)</h2>
          <ol>
            <li><strong>Step 1: Add Heading</strong><br />Go to “Add Heading”, enter heading name and unit.</li>
            <li><strong>Step 2: Add Materials</strong><br />Go to “Add & Edit Materials” and add required materials.</li>
            <li><strong>Step 3: Add Formula</strong><br />Use “Add Formula” to link heading with materials based on base quantity and material quantity.</li>
            <li>You can update formulas anytime for flexibility.</li>
          </ol>
        </section>

        <section className="howto-section">
          <h2>Adding a Fixed Price Heading (Type 2)</h2>
          <ol>
            <li><strong>Add Fixed Heading:</strong> Enter name and unit.</li>
            <li><strong>Add Makes & Characteristics:</strong> Define quality types and add multiple makes with their prices.</li>
          </ol>
        </section>

        <section className="howto-section">
          <h2> Best Practices</h2>
          <ul>
            <li>Use unique names for headings to avoid confusion.</li>
            <li>Ensure units are correctly defined for accurate results.</li>
            <li>Maintain consistent naming for materials.</li>
            <li>Use quotation builder during client meetings for quick estimates.</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default HowToUse;
